import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  contentItem: {
    maxWidth: 270,
    height: "auto",
    borderRadius: 8,
    borderWidth: 0.5,
    borderColor: "#FFF",
    paddingVertical: 6,
    paddingHorizontal: 6,
    flexDirection: "row",
    marginBottom: 10,
    marginRight: 10,
    justifyContent: "space-between",
    alignContent: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },

  tokenBtnsContainer: {
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignSelf: "center",
    alignItems: "center",
    minWidth: 240,
  },

  img: {
    width: 24,
    height: 24,
    marginRight: 8,
    borderRadius: 50,
  },
  textsItem: {
    marginTop: 8,
  },

  btnComprar: {
    minWidth: 120,
    height: 34,
    paddingHorizontal: 6,
    paddingVertical: 4,
    borderRadius: 4,
    borderColor: "#077A97",
    borderWidth: 0.5,
    backgroundColor: "#077A97",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 10,
  },

  btnComprarText: {
    color: "#fff",
  },

  btnSaibaMais: {
    minWidth: 120,
    height: 34,
    paddingHorizontal: 6,
    paddingVertical: 4,
    borderRadius: 4,
    borderColor: "#077A97",
    borderWidth: 0.5,
    justifyContent: "center",
    alignItems: "center",
  },

  btnSaibaMaisText: {
    color: "#033D4B",
  },

  infoAtivoContainer: {
    alignSelf: "flex-start",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: 10,
    flexWrap: "wrap",
  },
  titleCoin: {
    flexWrap: "wrap",
    maxWidth: 240,
    fontSize: 14,
    flexShrink: 1,
    fontWeight: "600",
  },
  infosCoin: {
    fontSize: 10,
    color: "#2C2C2E",
    fontWeight: "400",
  },
  priceCoin: {
    fontSize: 14,
    flexShrink: 1,
  },
});

export default styles;
